import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import AppSettingsCampaignsComponent from '../campaigns'
import AppSettingsSyncComponent from '../sync'
import AppSettingsUserComponent from '../user'
import AppSettingsSidebarWidgetsComponent from '../sidebar-widgets'
import AppSettingsPromotionsComponent from '../promotions';

class AppSettingsContentComponent extends Component {
    render() {
        return (
			<div className="medium-9 cell settings--content">
				<div className="grid-x grid-padding-x grid-padding-y">
					<Route exact path="/app/settings/campaigns" component={ AppSettingsCampaignsComponent } />
					<Route exact path="/app/settings/sync" component={ AppSettingsSyncComponent } />
					<Route exact path="/app/settings/user" component={ AppSettingsUserComponent } />
					<Route exact path="/app/settings/sidebar-widgets" component={ AppSettingsSidebarWidgetsComponent } />
					<Route exact path="/app/settings/promotions" component={ AppSettingsPromotionsComponent } />
				</div>
			</div>
        )
    }
}

export default AppSettingsContentComponent


// WEBPACK FOOTER //
// ./src/application/components/settings/parts/content.js